"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _style = _interopRequireDefault(require("./style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Button(props) {
  return /*#__PURE__*/_react["default"].createElement(_style["default"], {
    className: "button ".concat(props.type || 'default', " ").concat(props.className || ''),
    shape: props.shape || 'round',
    type: props.type || 'default',
    size: props.size || 'medium',
    disabled: props.disabled || false,
    "float": props["float"] || false,
    onClick: function onClick() {
      return props.onClick();
    }
  }, props.title);
}

Button.defaultProps = {
  type: 'default',
  shape: 'round',
  size: 'medium',
  disabled: false,
  title: 'Button',
  "float": false
};
Button.propTypes = {
  type: _propTypes["default"].string,
  shape: _propTypes["default"].string,
  size: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  "float": _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = Button;
exports["default"] = _default;